import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TabCallsPage } from './tab-calls';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		TabCallsPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(TabCallsPage),
	],
})
export class TabCallsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/tab-calls/tab-calls.module.ts